module.exports = __webpack_public_path__ + "img/fan-normal.051b0ef6.gif";